export const QR_CODE_BANK_PAYMENT_METHOD = '/static/images/payment/payment.png';

export default {
  QR_CODE_BANK_PAYMENT_METHOD,
};
